<template>
	<button
			class="text-button button p-0"
			:class="'size-'+size"
			:disabled="disabled"
			@click.prevent.stop="onClick"
	>
			<slot name="icon"></slot>
			{{ label }}
	</button>
</template>
<script>
	export default{
		name: 'SimplementsLinkButton',
		props: {
			label: {
				type: String
			},
			disabled: {
				type: Boolean
			},
			size: {
				type: String,
				default: 'lg'
			},
			width: {
				type: String,
				default: 'full'
			}
		},
		methods: {
			onClick(event){
				this.$emit('click', event)
			}
		}
	}
</script>
<style scoped>
	@import url(./assets/basic.css);
	.button.text-button{
		margin-top: var(--gab-sm);
		color: var(--primary, rgba(72, 142, 83, 0.93)) !important;
	}

	.button.text-button:hover{
		color: var(--neutral10, #333) !important;
	}
	.button.text-button:disabled{
		color: var(--neutral50, #8D8D8D) !important;
	}
</style>